export default "__VITE_ASSET__T1VsMsbh__"